(() => {
  const KEY = 'upup-sgd-cny-ecb-v1';
  const DAY = 86400000;
  const RETRY = 300000;
  let cached = null;
  let pending = null;
  let attempted = 0;
  const valid = (r) => r && r.base === 'SGD' && r.quote === 'CNY' && typeof r.rate === 'number' && Number.isFinite(r.rate) && r.rate > 0 && /^\d{4}-\d{2}-\d{2}$/.test(r.date) && Number.isFinite(Date.parse(r.date)) && Date.parse(r.date) <= Date.now() + DAY && Number.isFinite(r.fetchedAt) && r.fetchedAt > 0 && r.fetchedAt <= Date.now();
  try {
    const saved = JSON.parse(localStorage.getItem(KEY));
    if (valid(saved)) cached = saved;
  } catch {}
  async function rate() {
    if (cached && Date.now() - cached.fetchedAt < DAY) return cached;
    if (pending) return pending;
    if (attempted && Date.now() - attempted < RETRY) return cached;
    attempted = Date.now();
    pending = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch('https://api.frankfurter.dev/v2/rate/SGD/CNY?providers=ecb', {signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer'});
        if (!response.ok) throw new Error('Rate unavailable');
        const next = {...await response.json(), fetchedAt: Date.now()};
        if (!valid(next)) throw new Error('Invalid rate');
        if (!cached || next.date >= cached.date) {
          cached = next;
          try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
        }
      } catch {} finally { clearTimeout(timeout); }
      return cached;
    })();
    try { return await pending; } finally { pending = null; }
  }
  class ReferencePrice extends HTMLElement {
    connectedCallback() {
      if (this.dataset.currency !== 'SGD' || this.ready) return;
      this.ready = true;
      this.amount = Number(this.dataset.price);
      try { this.variants = JSON.parse(this.querySelector('[data-variant-prices]').textContent); } catch { this.variants = {}; }
      this.section = this.closest('.product-page');
      this.onChange = (event) => {
        if (event.target.matches('[name="id"]')) this.select(event.target.value);
      };
      this.onHistory = () => this.select(new URL(location.href).searchParams.get('variant') || this.dataset.variant);
      this.onVisible = () => { if (!document.hidden) this.refresh(); };
      this.section?.addEventListener('change', this.onChange);
      window.addEventListener('popstate', this.onHistory);
      document.addEventListener('visibilitychange', this.onVisible);
      this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, RETRY);
      this.draw(cached);
      this.refresh();
    }
    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onChange);
      window.removeEventListener('popstate', this.onHistory);
      document.removeEventListener('visibilitychange', this.onVisible);
      clearInterval(this.timer);
      this.ready = false;
    }
    select(id) {
      if (!Object.prototype.hasOwnProperty.call(this.variants, id)) return;
      this.amount = this.variants[id];
      this.querySelector('[data-primary-price]').textContent = `S$${(this.amount / 100).toLocaleString('en-SG', {minimumFractionDigits: 0, maximumFractionDigits: 2})}`;
      this.draw(cached);
    }
    async refresh() {
      const result = await rate();
      if (this.isConnected) this.draw(result);
    }
    draw(result) {
      const reference = this.querySelector('[data-reference]');
      const show = valid(result) && Number.isFinite(this.amount) && this.amount >= 0;
      reference.hidden = !show;
      if (!show) return;
      this.querySelector('[data-cny-price]').textContent = `≈ ¥${Math.round(this.amount / 100 * result.rate).toLocaleString('en-SG')}`;
      reference.dataset.rateDate = result.date;
      reference.dataset.updatedAt = new Date(result.fetchedAt).toISOString();
      reference.title = `ECB via Frankfurter · ${result.date}`;
    }
  }
  if (!customElements.get('upup-reference-price')) customElements.define('upup-reference-price', ReferencePrice);
})();
